import { Provider } from 'react-redux';
import { Outlet } from 'react-router-dom';

import reportingStore from '@/components/reporting/store/reportingStore';

import './reportingLayout.scss';

export default function ReportingLayout() {
  return (
    <Provider store={reportingStore}>
      <div className="reportingLayout">
        <div className="reportingLayout__content">
          <Outlet />
        </div>
      </div>
    </Provider>
  );
}
